import { ILoginSession } from 'types/session';

import { REMOVE_LOGIN_SESSION, SET_LOGIN_SESSION, SET_LOGIN_FETCHING, SET_TPC_ENABLED } from './login.constants';
import {
    LOAD_UBISOFT_OVERLAY_DONE
} from '../ubisoft-connect-overlay-provider/ubisoft-connect-overlay-provider.constants';
import { Actions } from 'modules/login/login.actions';

export interface IState {
    fetching: boolean;
    loginSession?: ILoginSession;
    hasTPCEnabled: boolean | null;
    hasOverlayLoaded: boolean;
}

export const initialState: IState = {
    fetching: false,
    hasTPCEnabled: null,
    hasOverlayLoaded: false
};

export const reducerKey = 'login' as const;

export const login = (state = initialState, action: Actions): IState => {
    switch (action.type) {
    case SET_LOGIN_FETCHING:
        return {
            ...state,
            fetching: action.payload
        };
    case SET_LOGIN_SESSION:
        return {
            ...state,
            loginSession: action.payload
        };
    case SET_TPC_ENABLED:
        return {
            ...state,
            hasTPCEnabled: action.payload
        };
    // case is handled from loadUbisoftConnectOverlay action
    // @ts-ignore
    case LOAD_UBISOFT_OVERLAY_DONE:
        return {
            ...state,
            hasOverlayLoaded: true
        };
    case REMOVE_LOGIN_SESSION:
        return {
            ...initialState,
            hasOverlayLoaded: !!state.hasOverlayLoaded
        };
    default:
        return state;
    }
};

export default login;
